import { createContext, useMemo, useReducer } from "react";
import combineReducers from "react-combine-reducers";
import { alertInitialState, alertReducer } from "src/reducers/alertReducer";
import { categoryInitialState, categoryReducer } from "src/reducers/categoryReducer";
import { globalInitialState, globalReducer } from "src/reducers/globalReducer";
import { notificationIntitialState, notificationReducer } from "src/reducers/notificationReducer";
import { notificationsReducer, notificationsInitialState } from "src/reducers/notificationsReducer";

export const GlobalContext = createContext();

const [rootReducer, initialState] = combineReducers({
  globalState: [globalReducer, globalInitialState],
  categoryState: [categoryReducer, categoryInitialState],
  alertState: [alertReducer, alertInitialState],
  notificationState: [notificationReducer, notificationIntitialState],
  notificationsState: [notificationsReducer, notificationsInitialState]
});

export const Store = ({ children }) => {
  const [state, dispatch] = useReducer(rootReducer, initialState, (initState) => initState);

  const storeValue = useMemo(() => ({ state, dispatch }), [state]);

  return <GlobalContext.Provider value={storeValue}>{children}</GlobalContext.Provider>;
};
